import React from 'react';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import theme from './BreakTab.scss';

import VehicleBreak from 'common/components/common/breaks/VehicleBreak';
import { Button, ButtonTypes } from 'common/components/core/button';

const DefaultBreakEmptyState = ({ theme, breakType, addBreak, t }) => {
    return (
        <div className={theme.emptyDialog}>
            <img
                className={theme.emptyImage}
                src={`img/${breakType.toLowerCase()}-empty.png`}
            />
            <span className={theme.emptyText}>
                {t('noBreaksAdded', { type: breakType.toLowerCase() })}
            </span>
            <Button
                ripple={false}
                buttonType={ButtonTypes.Link}
                onClick={addBreak}
                label={t('addNewBreak')}
                theme={theme}
            />
        </div>
    );
};
const breakTabFactory = ({
    SingleBreak = VehicleBreak,
    BreakEmptyState = DefaultBreakEmptyState
}) => {
    class BreakTab extends React.Component {
        addBreak = () => {
            const { addBreak, breakType } = this.props;
            addBreak && addBreak(breakType);
        };
        render() {
            const {
                theme,
                breaks,
                unappliedBreaks,
                activeBreakKey,
                breakType,
                deleteBreak,
                onBreakValueChange,
                handleFieldFocus,
                currentDate,
                getBreakKey,
                homebases,
                breakSlotFor,
                shiftStart,
                shiftEnd,
                endDayOffset,
                t
            } = this.props;
            if (!breaks.length) {
                return (
                    <BreakEmptyState
                        breakType={breakType}
                        addBreak={this.addBreak}
                        theme={theme}
                        t={t}
                    />
                );
            }
            return (
                <div className={theme.breaksListWrap}>
                    <div className={theme.breaksList}>
                        {breaks.map((breakShift, index) => {
                            const key = getBreakKey({
                                breakType,
                                breakIndex: index
                            });
                            const isActive = activeBreakKey === key;
                            const isUnapplied =
                                unappliedBreaks.indexOf(key) >= 0;
                            return (
                                <SingleBreak
                                    homebases={homebases}
                                    currentDate={currentDate}
                                    handleFieldFocus={handleFieldFocus}
                                    onBreakValueChange={onBreakValueChange}
                                    deleteBreak={deleteBreak}
                                    theme={theme}
                                    breakType={breakType}
                                    breakKey={key}
                                    breakIndex={index}
                                    isActive={isActive}
                                    isUnapplied={isUnapplied}
                                    breakShift={breakShift}
                                    key={key}
                                    t={t}
                                    breakSlotFor={breakSlotFor}
                                    shiftStart={shiftStart}
                                    shiftEnd={shiftEnd}
                                    endDayOffset={endDayOffset}
                                />
                            );
                        })}
                    </div>
                    <Button
                        ripple={false}
                        buttonType={ButtonTypes.Link}
                        onClick={this.addBreak}
                        label={t('addAnotherBreak')}
                        theme={theme}
                        className={theme.addBreakLink}
                    />
                </div>
            );
        }
    }
    return compose(themr('BreakTab', theme), translate('configure'))(BreakTab);
};
export { breakTabFactory };
export default breakTabFactory;
